  const hexToRgb = (hexColor, opacity = 0.65) => {
    const hex = hexColor.replace(/^#/, '');
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    const darkerR = Math.max(0, Math.floor(r * 0.6));
    const darkerG = Math.max(0, Math.floor(g * 0.6));
    const darkerB = Math.max(0, Math.floor(b * 0.6));
    const darkerHex = `rgba(${darkerR}, ${darkerG}, ${darkerB}, ${opacity})`;
    return darkerHex;
  };

  export default hexToRgb;